


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import NotFoundError from 'frontend/views/lessons/lesson/svgs/NotFoundError.vue';
import Button from 'frontend/components/Button.vue';

@Component({
  components: { Button, NotFoundError },
})
export default class LessonErrorScreen extends Vue {
  private onCloseClicked(): void {
    this.$emit('closeClicked');
  }
}
